export default "__VITE_PUBLIC_ASSET__2fb1c2b3__"